/*
  HU06 Preventa -- "Picking Individual Preventa" (TASKID 243, flowBolCI09).
  Nuevo, no es un clon de externalForm06.js -- ver
  docs/picking-preventa-form-design.md para el alcance exacto y
  docs/picking-individual-capabilities-map.md para el mapa completo de
  capacidades de Picking Individual (de donde sale este subconjunto).

  Alcance (confirmado por Yambert, 2026-09-16): scan/pick, ajustar
  cantidad (+/-), agregar/quitar producto, facturar -- todo limitado a
  items con es_preventa=true del pedido. Sin gate de rol (isSupervisor/
  isAdmin): el gate real de esta tarea es la fecha+SAP que ya paso en
  Picking Global Preventa (242) antes de llegar aca.

  Cambio 30/10/2026 (filas 19 y 25 de las pruebas): en envio regular
  (tipo_envio==="weight") el orden es Picking Global -> Picking Preventa ->
  Picking Individual y la factura, unica y con todos los productos, se emite
  en Picking Individual (externalForm06). Aca ya no se factura: la API de
  facturacion valida contra SAP y la preventa recien llega a SAP cuando esta
  tarea termina.
*/
import React from "react";
import {
  MDBNotification,
  MDBInputGroup,
  toast,
  MDBBadge,
  MDBAnimation,
  ToastContainer,
  MDBIcon,
  MDBDataTable,
  MDBAlert,
  MDBModal,
  MDBModalBody,
  MDBModalHeader,
  MDBModalFooter,
  MDBCard,
  MDBCardBody,
  MDBCardHeader,
  MDBContainer,
  MDBRow,
  MDBCol,
  MDBBtnGroup,
} from "mdbreact";
import { XInput, XSelect, XBtn, XDatePicker } from "../../Components/XForm";
import Loader from "../../Components/Loader";
import { API_CONFIG } from "../../Config/config-env.js";
import axios from "axios";
import {
  applyExternalDarkMode,
  getCasaIdeasStores,
  getStoreCodeByOfficeCode,
} from "../../Config/functions";
import BarcodeScanner from "../../Components/BarcodeScanner";
import LockOverlay from "../../Components/LockOverlay";

// Toasts sin repetir: el mismo mensaje no se vuelve a mostrar mientras haya uno
// igual en pantalla (plan de pruebas PREVENTA 2026-10-08: al hacer varios clicks
// en un item que todavia no llego se apilaban N avisos iguales).
const _toastVisto = {};
const toastOnce = (tipo, mensaje, opciones) => {
  const clave = tipo + "|" + mensaje;
  const ahora = Date.now();
  if (_toastVisto[clave] && ahora - _toastVisto[clave] < 4000) return;
  _toastVisto[clave] = ahora;
  return toast[tipo](mensaje, opciones);
};

class externalForm11 extends React.Component {
  state = {
    loadingData: true,
    isLoadedTable: false,
    isExecuting: false,
    locked: false,

    token: "",
    WO_Id: "",
    WO_TaskId: "",
    officecode: "",
    flowcode: "",
    flowid: "",
    username: "",
    invoice_user: "",

    order_id: "",
    customer_id: "",
    customerName: "",
    branch_name: "",
    tipo_envio: "",

    orders: [],
    preventaMap: {},
    preventaMapLoaded: false,
    consultandoPreventa: false,
    read_sku: "",
    progress_i: 0,
    picking_products_i: "",

    // agregar producto
    modalAdd: false,
    SKUcode: "",
    searchResults: [],
    productoAAgregar: null,
    checkandoSku: false,
    skuEsPreventa: null,
    skuCheckMessage: "",
    skuCheckWarehouse: "",

    // eliminar (confirm)
    modalDelete: false,
    id_producto: -1,

    // facturacion (mismo contrato que externalForm06 -- conector real no se toca)
    numero_factura: "",
    invoice_response: "",
    invoice_status: "",
    TRX: "0",
    intento_facturacion: 0,
    metodo_pago: "",
    monto_total: 0,
    from_date: new Date(),
    razon_social: "",
    nit: "",
    direccion_1: "",
    direccion_2: "",
    telefono: "",
    email: "",
    ciudad: "",
    codigo_cupon: "",
    modalFacturaBypass: false,
    opcion: "",

    // HU06 Preventa -- posicion de rack para pickup (no aplica a delivery,
    // que ya factura con tipo_envio==="weight" arriba). Necesario sobre todo
    // para el pedido 100% preventa, que nunca pasa por Picking Individual.
    posicion_rack: "",

    // HU06 Fase 1 -- nota SAP de la preventa que viaja en traspaso (nota #2). Solo
    // se pide cuando la oficina de este subflujo esta en preventa_traspaso_offices
    // (tiendas con preventa distintas a la de pickup, las deja la tarea 248).
    nota_sap_preventa: "",
    requiereNotaSapPreventa: false,
  };

  componentDidMount = async () => {
    await this.LoadTable();
  };

  // HU06 Preventa -- marca visual por SKU (rojo = todavia no llego, verde =
  // ya confirmada/vuelta a stock normal). Mismo endpoint que usa el gate de
  // "Picking Preventa"/"Picking Global Preventa" (externalForm12.js). Todos
  // los items de este form ya son de preventa (LoadTable los filtra), asi
  // que no hace falta chequear si el sku esta en la respuesta.
  loadPreventaStatus = async (order_id) => {
    if (!order_id || this.state.consultandoPreventa) return;
    this.setState({ consultandoPreventa: true });
    await axios({
      method: "post",
      headers: { "Content-Type": "application/json" },
      url: API_CONFIG.casaideasInt + "/api/preventa/checkDisponibilidad",
      data: { order_id, apikey: API_CONFIG.casaideasIntToken },
    })
      .then((r) => r.data)
      .then((data) => {
        const preventaMap = {};
        (data.items || []).forEach((item) => {
          preventaMap[item.sku] = item.disponible;
        });
        this.setState({ preventaMap, preventaMapLoaded: true, consultandoPreventa: false });
        // Si nada cambió la pantalla queda igual: sin este aviso el botón
        // parece no hacer nada.
        const pendientes = this.state.orders.filter((o) => preventaMap[o.productSKU] !== true).length;
        if (pendientes) {
          toastOnce("info", `Consultado: ${pendientes} de ${this.state.orders.length} item(s) todavia no llegaron.`, {
            closeButton: true,
          });
        } else {
          toastOnce("success", "Llego toda la preventa: ya se puede pickear.", { closeButton: true });
        }
      })
      .catch(() => {
        // Sin respuesta no se sabe si llego: se deja bloqueado el pick y se
        // puede reintentar con "Volver a consultar".
        this.setState({ preventaMapLoaded: true, consultandoPreventa: false });
        toastOnce("error", "No se pudo consultar la llegada de la preventa, reintenta.", { closeButton: true });
      });
  };

  // ---------------------------------------------------------------------
  // Carga: mismo patron que LoadTable() de externalForm06.js (get-task-
  // details -> flowvars -> getorderById), pero filtrado a es_preventa=true
  // desde el vamos -- este form nunca ve ni toca items con stock real.
  // ---------------------------------------------------------------------
  LoadTable = async () => {
    let params = new URLSearchParams(this.props.location.search);
    applyExternalDarkMode(this.props.location.search);
    const token = params.get("token");
    const WO_Id = params.get("wfpflowid");
    const WO_TaskId = params.get("wfptaskid");
    const locked = params.get("locked") === "true";
    const officecode = params.get("officecode");

    this.setState({ loadingData: true, token, WO_Id, WO_TaskId, officecode, locked });

    let order_id = 0;
    let customer_id = 0;
    let nombre_cliente = "";
    let branch_name = "";
    let tipo_envio = "";
    let picking_products_i = "";
    let progress_i = 0;
    let username = "";
    let flowcode = "";
    let flowid = "";
    let pedidoParcial = "NO";
    let tiendaOrigen = "";
    let parentFlowcode = "";
    let traspasoOffices = "";
    let notaSapPreventa = "";

    const taskDetails = await axios({
      headers: { "Content-Type": "application/json", Authorization: "Bearer " + token },
      url: API_CONFIG.xflowurl + "/engine-users/get-task-details",
      data: { wfptaskid: WO_TaskId },
      method: "post",
    }).then((r) => r.data);

    if (!taskDetails.status) {
      toastOnce("error", "No se pudo cargar la tarea", { closeButton: true });
      this.setState({ loadingData: false });
      return;
    }

    flowcode = taskDetails.task.FLOWCODE;
    flowid = taskDetails.task.FLOWID;
    username = taskDetails.token ? taskDetails.token.USERNAME : "";

    for (const v in taskDetails.flowvars) {
      const flowVar = taskDetails.flowvars[v];
      if (flowVar.VARNAME === "order_id") order_id = flowVar.VARVALUE;
      if (flowVar.VARNAME === "customer_id") customer_id = flowVar.VARVALUE;
      if (flowVar.VARNAME === "nombre_cliente") nombre_cliente = flowVar.VARVALUE;
      if (flowVar.VARNAME === "branch_name") branch_name = flowVar.VARVALUE;
      if (flowVar.VARNAME === "tipo_envio") tipo_envio = flowVar.VARVALUE;
      if (flowVar.VARNAME === "picking_products_i") picking_products_i = flowVar.VARVALUE;
      if (flowVar.VARNAME === "progress_i") progress_i = parseInt(flowVar.VARVALUE) || 0;
      if (flowVar.VARNAME === "direccion_1") this.state.direccion_1 = flowVar.VARVALUE;
      if (flowVar.VARNAME === "nit") this.state.nit = flowVar.VARVALUE;
      if (flowVar.VARNAME === "posicion_rack") this.state.posicion_rack = flowVar.VARVALUE;
      if (flowVar.VARNAME === "pedido_parcial") pedidoParcial = flowVar.VARVALUE;
      if (flowVar.VARNAME === "officecodeONLINE") tiendaOrigen = flowVar.VARVALUE;
      if (flowVar.VARNAME === "subflow_parent_flowcode") parentFlowcode = flowVar.VARVALUE;
      if (flowVar.VARNAME === "preventa_traspaso_offices") traspasoOffices = flowVar.VARVALUE;
      if (flowVar.VARNAME === "nota_sap_preventa") notaSapPreventa = flowVar.VARVALUE;
    }

    // Cada subflujo de preventa nace en la tienda donde está cargada su
    // preventa (fan-out de la tarea "Preventa", ver
    // xflow_backv2/docs/hu06-preventa-subflujo.md, punto 14) y pickea solo los
    // SKUs de esa tienda. La tienda de cada SKU sale del warehouse_code de
    // checkDisponibilidad, no de mixed_skus: mixed_skus viene de
    // reserved_quantity, que para preventa es siempre 0, y pone toda la
    // preventa del pedido en la misma tienda (con eso el subflujo de LP01
    // mostraba también la preventa de LP02 y el de LP02 no mostraba nada).
    // La misma respuesta alimenta la marca llegó/no llegó por SKU.
    const disponibilidad = await axios({
      method: "post",
      headers: { "Content-Type": "application/json" },
      url: API_CONFIG.casaideasInt + "/api/preventa/checkDisponibilidad",
      data: { order_id, apikey: API_CONFIG.casaideasIntToken },
    })
      .then((r) => r.data)
      .catch(() => null);
    const tiendaPorSku = {};
    ((disponibilidad && disponibilidad.items) || []).forEach((item) => {
      tiendaPorSku[item.sku] = String(item.warehouse_code || "")
        .trim()
        .replace(/^MD-/i, "");
    });
    const esDeEsteFlujo = (sku) => {
      if (!parentFlowcode) return true;
      const tienda = tiendaPorSku[sku];
      return !tienda || tienda === officecode;
    };

    let apikey = API_CONFIG.casaideasIntToken;
    const orderResp = await axios({
      url: API_CONFIG.getorderByIdpath,
      method: "post",
      data: { apikey, order_id, customer_id, adminpath: "matrix" },
    }).then((r) => r.data);

    let orderInfo = (orderResp.response && orderResp.response[0] && orderResp.response[0].order_info) || {};
    let products = (orderResp.response && orderResp.response[0] && orderResp.response[0].products) || [];

    const arrayPicked = picking_products_i ? picking_products_i.split("|") : [];

    const orders = products
      .filter((p) => !!p.es_preventa && esDeEsteFlujo(p.sku))
      .map((p, idx) => {
        const picked = arrayPicked.find((row) => row.split(",")[0] == p.id);
        let qtyPicked = 0;
        let isPicked = -1;
        if (picked) {
          const data = picked.split(",");
          qtyPicked = parseInt(data[1]);
          isPicked = data[1] == data[2] ? 1 : -1;
        }
        return {
          id: p.id,
          product_id: p.id,
          productName: p.name,
          productModel: p.model || p.sku,
          productSKU: p.sku,
          productImage: p.imagen,
          productQty: parseInt(p.quantity),
          precio: p.precio || 0,
          precio_lista: p.precio_lista || p.price || 0,
          isPicked,
          qtyPicked,
          state: "loaded",
        };
      });

    let totalPicked = orders.filter((o) => o.isPicked > 0).length;

    this.setState({
      loadingData: false,
      isLoadedTable: true,
      requiereNotaSapPreventa: String(traspasoOffices || "")
        .split(",")
        .map((t) => t.trim().replace(/^MD-/i, ""))
        .includes(String(officecode || "").trim().replace(/^MD-/i, "")),
      nota_sap_preventa: notaSapPreventa || "",
      orders,
      order_id,
      customer_id,
      customerName: nombre_cliente,
      branch_name,
      tipo_envio,
      picking_products_i,
      progress_i: orders.length ? Math.ceil((totalPicked / orders.length) * 100) : 100,
      username,
      invoice_user: username,
      flowcode,
      flowid,
      monto_total: Number(
        (orderInfo.SUBTOTAL - orderInfo.DISCOUNT + orderInfo.SHIPPINGCOST || 0).toFixed
          ? (orderInfo.SUBTOTAL - orderInfo.DISCOUNT + orderInfo.SHIPPINGCOST).toFixed(2)
          : 0
      ),
    });

    if (disponibilidad) {
      const preventaMap = {};
      (disponibilidad.items || []).forEach((item) => {
        preventaMap[item.sku] = item.disponible;
      });
      this.setState({ preventaMap, preventaMapLoaded: true });
    } else {
      // Sin respuesta no se sabe si llegó: se deja bloqueado el pick y se
      // puede reintentar con "Volver a consultar".
      this.setState({ preventaMapLoaded: true });
    }
  };

  // ---------------------------------------------------------------------
  // Scan + pick -- mismo patron que changeHandlerSKU/handleBarcodeDetected/
  // handlePick de externalForm06.js, sobre this.state.orders (que ya viene
  // pre-filtrado a preventa, asi que un SKU con stock real simplemente no
  // matchea nunca aca).
  // ---------------------------------------------------------------------
  changeHandlerSKU = async (event) => {
    const value = event.target.value;
    this.setState({ read_sku: value });
    if (value.length < 8) return;

    const item = this.state.orders.find((o) => o.productSKU == value);
    if (!item) {
      this.setState({ read_sku: "" });
      toastOnce("error", "SKU no encontrado entre los items de preventa de este pedido", {
        closeButton: true,
      });
      return;
    }
    const qty = (item.qtyPicked || 0) + 1;
    if (qty <= item.productQty) {
      await this.handlePick(item.id, qty);
      this.setState({ read_sku: "" });
      toastOnce("success", "OK: " + value, { closeButton: true });
    } else {
      this.setState({ read_sku: "" });
      toastOnce("error", "Cantidad del SKU " + value + " superada", { closeButton: true });
    }
  };

  handleBarcodeDetected = (value) => {
    this.changeHandlerSKU({ target: { name: "read_sku", value: value.trim() } });
  };

  handlePick = async (producto, qty) => {
    if (this.state.locked) return;
    if (!this.state.preventaMapLoaded) {
      toastOnce("warning", "Consultando la llegada de la preventa, intenta en un momento.", { closeButton: true });
      return;
    }
    const objetivo = this.state.orders.find((o) => o.id == producto);
    if (objetivo && this.state.preventaMap[objetivo.productSKU] !== true) {
      toastOnce("warning", `"${objetivo.productName}" todavia no llego: no se puede pickear.`, { closeButton: true });
      return;
    }
    this.setState({ isExecuting: true });

    const orders = this.state.orders.map((o) => {
      if (o.id != producto) return o;
      if (qty) {
        return { ...o, qtyPicked: qty, isPicked: qty === o.productQty ? 1 : -1 };
      }
      return {
        ...o,
        qtyPicked: o.isPicked === -1 ? o.productQty : 0,
        isPicked: o.isPicked === -1 ? 1 : -1,
      };
    });

    let product_ids = [];
    let totalPicked = 0;
    for (const o of orders) {
      if (o.qtyPicked > 0) product_ids.push(`${o.product_id},${o.qtyPicked},${o.productQty}`);
      if (o.isPicked > 0) totalPicked++;
    }
    const progress_i = orders.length ? Math.ceil((totalPicked / orders.length) * 100) : 0;
    const picking_products_i = product_ids.join("|");

    await axios({
      url: API_CONFIG.xflowurl + "/engine-users/save-flow-field",
      method: "put",
      data: {
        WO_flowID: this.state.WO_Id,
        WO_TaskID: this.state.WO_TaskId,
        params: [
          { var: "picking_products_i", value: picking_products_i },
          { var: "progress_i", value: progress_i },
        ],
      },
      headers: { "Content-Type": "application/json", Authorization: "Bearer " + this.state.token },
    });

    this.setState({ orders, progress_i, picking_products_i, isExecuting: false });
  };

  // ---------------------------------------------------------------------
  // Ajustar cantidad / eliminar -- mismo endpoint que handleCommitEdit /
  // handleCommitDelete de externalForm06.js: POST /api/orders/update
  // action=updateOrderProductQty (quantity=0 = eliminar). Sin gate de rol
  // (a diferencia del original, donde esto requeria isSupervisor).
  // ---------------------------------------------------------------------
  // Tienda (warehouse_code) donde esta cargada la preventa de cada SKU del pedido.
  // El backend la usa para atribuir el cambio de cantidad a la porcion correcta
  // (pickup u origen); con isPickup:false fijo, las unidades extra caian en la
  // porcion origen y salian como stock normal.
  resolveWarehouse = async (sku) => {
    if (!this._whCache) {
      this._whCache = {};
      try {
        const d = await axios({
          method: "post",
          headers: { "Content-Type": "application/json" },
          url: API_CONFIG.casaideasInt + "/api/preventa/checkDisponibilidad",
          data: { order_id: this.state.order_id, apikey: API_CONFIG.casaideasIntToken },
        }).then((r) => r.data);
        ((d && d.items) || []).forEach((i) => {
          this._whCache[i.sku] = String(i.warehouse_code || "").trim();
        });
      } catch (e) {
        this._whCache = null;
      }
    }
    return (this._whCache && this._whCache[sku]) || "";
  };

  commitQtyChange = async (item, newQty) => {
    if (this.state.locked) return;
    this.setState({ isExecuting: true });

    const dataDelOrder = {
      id: item.id,
      orderid: this.state.order_id,
      user: this.state.username,
      quantity: newQty,
      sku: item.productSKU,
      apikey: API_CONFIG.casaideasIntToken,
      isPickup: false,
      warehouse_code: await this.resolveWarehouse(item.productSKU),
      action: "updateOrderProductQty",
    };

    const resp = await axios({
      method: "post",
      headers: { "Content-Type": "application/json" },
      url: API_CONFIG.casaideasInt + "/api/orders/update",
      data: dataDelOrder,
    }).then((r) => r.data);

    if (!resp.status) {
      toastOnce("error", "ERROR: " + (resp.descResp || "no se pudo actualizar"), { closeButton: true });
      this.setState({ isExecuting: false });
      return;
    }

    const orders =
      newQty === 0
        ? this.state.orders.filter((o) => o.id !== item.id)
        : this.state.orders.map((o) => (o.id === item.id ? { ...o, productQty: newQty } : o));

    await axios({
      url: API_CONFIG.xflowurl + "/engine-users/save-flow-field",
      method: "put",
      data: {
        WO_flowID: this.state.WO_Id,
        WO_TaskID: this.state.WO_TaskId,
        params: [
          { var: "pedido_modificado", value: "SI" },
          { var: "monto_total", value: resp.total },
        ],
      },
      headers: { "Content-Type": "application/json", Authorization: "Bearer " + this.state.token },
    });

    toastOnce("success", "OK: Procesado Correctamente", { closeButton: true });
    this.setState({ orders, monto_total: resp.total, isExecuting: false });
  };

  handleIncrement = (item) => this.commitQtyChange(item, item.productQty + 1);
  handleDecrement = (item) =>
    item.productQty <= 1
      ? this.setState({ modalDelete: true, id_producto: item.id })
      : this.commitQtyChange(item, item.productQty - 1);
  handleDeleteClick = (item) => this.setState({ modalDelete: true, id_producto: item.id });
  confirmDelete = () => {
    const item = this.state.orders.find((o) => o.id === this.state.id_producto);
    this.setState({ modalDelete: false });
    if (item) this.commitQtyChange(item, 0);
  };

  // ---------------------------------------------------------------------
  // Agregar producto -- mismo patron que searchProduct/addOrder de
  // externalForm06.js (api/products/search + api/orders/update
  // action=addOrderProduct). NO existe hoy un endpoint que confirme "este
  // SKU es de preventa" -- se pide confirmacion manual al operador como
  // salvaguarda minima. TODO real: exponer esa validacion del lado
  // backend (manageStocks/manageProducts) y sacar este checkbox.
  // ---------------------------------------------------------------------
  searchProduct = async () => {
    this.setState({ isExecuting: true, searchResults: [] });
    const resp = await axios({
      method: "post",
      headers: { "Content-Type": "application/json" },
      url: API_CONFIG.casaideasInt + "/api/products/search",
      data: { sku: this.state.SKUcode, apikey: API_CONFIG.casaideasIntToken },
    }).then((r) => r.data);

    if (resp.status && resp.result.length > 0) {
      this.setState({
        searchResults: resp.result.map((r) => ({
          product_id: r.id,
          name: r.name,
          sku: r.sku,
          price: parseFloat(r.price),
        })),
        isExecuting: false,
      });
    } else {
      toastOnce("error", "SKU no encontrado en el catálogo", { closeButton: true });
      this.setState({ isExecuting: false });
    }
  };

  // HU06 Preventa -- valida contra /api/preventa/checkSku (manageIntegrations
  // -> manageOrdenes) apenas se elige un producto, en vez del checkbox de
  // confirmación manual que tenía esto antes. "Agregar" queda deshabilitado
  // hasta que la respuesta confirme es_preventa=true.
  seleccionarProductoAAgregar = async (producto) => {
    this.setState({
      productoAAgregar: producto,
      checkandoSku: true,
      skuEsPreventa: null,
      skuCheckMessage: "",
    });

    const resp = await axios({
      method: "post",
      headers: { "Content-Type": "application/json" },
      url: API_CONFIG.casaideasInt + "/api/preventa/checkSku",
      data: { order_id: this.state.order_id, sku: producto.sku, apikey: API_CONFIG.casaideasIntToken },
    })
      .then((r) => r.data)
      .catch(() => ({ status: false, message: "No se pudo validar el SKU" }));

    this.setState({
      checkandoSku: false,
      skuEsPreventa: !!resp.es_preventa,
      skuCheckMessage: resp.message || "",
      skuCheckWarehouse: (resp.detalle && resp.detalle.warehouse_code) || "",
    });
  };

  addProduct = async () => {
    if (this.state.locked) return;
    const p = this.state.productoAAgregar;
    if (!p) return;
    if (!this.state.skuEsPreventa) {
      toastOnce("warning", "Este SKU no está confirmado como preventa, no se puede agregar", { closeButton: true });
      return;
    }
    // Mismo SKU ya en el pedido: se suma 1 a la linea existente (antes se creaba
    // una segunda linea con el mismo SKU).
    const existente = this.state.orders.find((o) => o.productSKU === p.sku);
    if (existente) {
      this.setState({
        modalAdd: false,
        productoAAgregar: null,
        skuEsPreventa: null,
        skuCheckMessage: "",
        SKUcode: "",
        searchResults: [],
      });
      await this.commitQtyChange(existente, existente.productQty + 1);
      return;
    }
    this.setState({ isExecuting: true });

    const dataNewOrder = {
      orderid: this.state.order_id,
      productid: p.product_id,
      productname: p.name,
      sku: p.sku,
      price: p.price,
      image: "",
      user: this.state.username,
      quantity: 1,
      apikey: API_CONFIG.casaideasIntToken,
      isPickup: false,
      warehouse_code: this.state.skuCheckWarehouse || "",
      action: "addOrderProduct",
    };

    const resp = await axios({
      method: "post",
      headers: { "Content-Type": "application/json" },
      url: API_CONFIG.casaideasInt + "/api/orders/update",
      data: dataNewOrder,
    }).then((r) => r.data);

    if (!resp.status) {
      toastOnce("error", "ERROR: no se pudo agregar el producto", { closeButton: true });
      this.setState({ isExecuting: false });
      return;
    }

    const nuevoItem = {
      id: resp.newId || `new_${p.sku}`,
      product_id: p.product_id,
      productName: p.name,
      productModel: p.sku,
      productSKU: p.sku,
      productImage: "",
      productQty: 1,
      precio: 0,
      precio_lista: p.price,
      isPicked: -1,
      qtyPicked: 0,
      state: "loaded",
    };

    await axios({
      url: API_CONFIG.xflowurl + "/engine-users/save-flow-field",
      method: "put",
      data: {
        WO_flowID: this.state.WO_Id,
        WO_TaskID: this.state.WO_TaskId,
        params: [
          { var: "pedido_modificado", value: "SI" },
          { var: "monto_total", value: resp.total },
        ],
      },
      headers: { "Content-Type": "application/json", Authorization: "Bearer " + this.state.token },
    });

    toastOnce("success", "Producto agregado", { closeButton: true });
    this.setState({
      orders: [...this.state.orders, nuevoItem],
      monto_total: resp.total,
      modalAdd: false,
      productoAAgregar: null,
      skuEsPreventa: null,
      skuCheckMessage: "",
      SKUcode: "",
      searchResults: [],
      isExecuting: false,
    });
  };

  changeHandler = (event) => {
    const name = event.target.name || event.target.id;
    this.setState({ [name]: event.target.value });
  };

  // ---------------------------------------------------------------------
  // Completar tarea -- misma validacion base que executeTask() de
  // externalForm06.js, recortada al alcance de esta tarea.
  // ---------------------------------------------------------------------
  executeTask = async () => {
    if (this.state.locked) return;
    let responseValidation = true;
    // Cambio de alcance 22/10/2026 (punto 2): si tras editar el pedido ya no queda preventa en esta tienda
    // (se borró o se quitó toda), la tarea se puede pasar sin rack, factura ni nota: no hay nada que entregar.
    const sinProductos = this.state.orders.length === 0;

    const pendientes = this.state.orders.filter((o) => this.state.preventaMap[o.productSKU] !== true);
    if (pendientes.length) {
      responseValidation = false;
      toastOnce("warning", "Todavia no llego toda la preventa de este pedido", { closeButton: true });
    } else if (this.state.progress_i < 100) {
      responseValidation = false;
      toastOnce("warning", "Debe pickear todos los productos de preventa", { closeButton: true });
    }
    if (!sinProductos && this.state.requiereNotaSapPreventa && !String(this.state.nota_sap_preventa || "").trim()) {
      responseValidation = false;
      toastOnce("warning", "Debe completar la Nota SAP del traspaso de preventa", { closeButton: true });
    }
    if (!sinProductos && this.state.tipo_envio !== "weight" && this.state.posicion_rack === "") {
      responseValidation = false;
      toastOnce("warning", "Debe completar la Posición Rack", { closeButton: true });
    }
    if (!responseValidation) return;

    this.setState({ isExecuting: true });

    await axios({
      headers: { "Content-Type": "application/json", Authorization: "Bearer " + this.state.token },
      url: API_CONFIG.xflowurl + "/engine-users/execute-task",
      data: {
        parentid: this.state.WO_TaskId,
        id: this.state.WO_TaskId,
        optionValue: "Pedido listo para entrega",
        params: sinProductos
          ? { posicion_rack: "N/A" }
          : this.state.requiereNotaSapPreventa
          ? { posicion_rack: this.state.posicion_rack, nota_sap_preventa: String(this.state.nota_sap_preventa).trim() }
          : { posicion_rack: this.state.posicion_rack },
      },
      method: "put",
    })
      .then((r) => r.data)
      .then((data) => {
        if (data.status) {
          toastOnce("success", "Procesado con éxito", { closeButton: true });
          setTimeout(() => window.parent.postMessage("TAREA_COMPLETADA", "*"), 1000);
        } else {
          toastOnce("error", "Error ejecutando la tarea: " + data.message, { closeButton: true });
        }
        this.setState({ isExecuting: false });
      });
  };

  render() {
    const { orders, loadingData } = this.state;

    return (
      <>
        <MDBContainer className="xext-page xext-form11">
          <LockOverlay visible={this.state.locked && !loadingData} />
          {loadingData ? (
            <Loader idLoading={loadingData} />
          ) : (
            <>
              <Loader idLoading={this.state.isExecuting} />

              <MDBCard className="mb-3">
                <MDBCardHeader>Picking Preventa — Pedido #{this.state.order_id}</MDBCardHeader>
                <MDBCardBody>
                  <MDBRow>
                    <MDBCol md="6">Cliente: {this.state.customerName}</MDBCol>
                    <MDBCol md="6"><span title="Avance del picking: unidades pickeadas sobre el total del pedido. Queda en 0% hasta que llegue la preventa y se pueda pickear.">
                      Progreso de picking: {this.state.progress_i}% ({this.state.orders.reduce((a, o) => a + (o.qtyPicked || 0), 0)}/
                      {this.state.orders.reduce((a, o) => a + (o.productQty || 0), 0)} unidades)
                    </span></MDBCol>
                  </MDBRow>
                </MDBCardBody>
              </MDBCard>

              {orders.length === 0 && (
                <div className="alert alert-info mb-3" role="alert">
                  <strong>No quedan productos de preventa en este pedido para esta tienda</strong> (se editó o se borró la
                  preventa desde Seguimiento de Pedidos). Puede completar la tarea para que el pedido continúe.
                </div>
              )}

              <MDBRow className="mb-3">
                <MDBCol md="6">
                  <XInput
                    id="read_sku"
                    name="read_sku"
                    label="Leer SKU (preventa)"
                    placeholder="Ingrese o escanee el código"
                    value={this.state.read_sku}
                    onChange={this.changeHandlerSKU}
                    size="sm"
                  />
                </MDBCol>
                <MDBCol md="3">
                  <BarcodeScanner disabled={this.state.isExecuting} onDetected={this.handleBarcodeDetected} />
                </MDBCol>
                <MDBCol md="3" className="text-right">
                  <XBtn size="sm" color="success" onClick={() => this.setState({ modalAdd: true })}>
                    <MDBIcon icon="cart-plus" /> Agregar producto preventa
                  </XBtn>
                </MDBCol>
              </MDBRow>

              {orders.length === 0 && (
                <MDBAlert color="info">No hay items de preventa para esta tienda: se puede completar la tarea.</MDBAlert>
              )}

              {(() => {
                const pendientes = orders.filter((o) => this.state.preventaMap[o.productSKU] !== true);
                if (!pendientes.length) return null;
                return (
                  <MDBAlert color="warning" className="xext-preventa-wait-banner">
                    <b>Esperando la llegada de la preventa.</b> {pendientes.length} de {orders.length} item(s) todavia no
                    llegaron a SAP; se podran pickear cuando lleguen.
                    <XBtn
                      size="sm"
                      outline
                      color="warning"
                      className="ml-2"
                      disabled={this.state.consultandoPreventa}
                      onClick={() => this.loadPreventaStatus(this.state.order_id)}
                    >
                      {this.state.consultandoPreventa ? (
                        <>
                          <MDBIcon icon="spinner" spin /> Consultando…
                        </>
                      ) : (
                        "Volver a consultar"
                      )}
                    </XBtn>
                  </MDBAlert>
                );
              })()}

              {orders.map((item) => (
                <MDBCard key={item.id} className="mb-2">
                  <MDBCardBody>
                    <MDBRow>
                      <MDBCol md="3" className="xext-item-actions">
                        <div className="xext-qty-stepper">
                          <button
                            type="button"
                            className={`xext-qty-btn ${item.productQty === 1 ? "xext-qty-del" : "xext-qty-minus"}`}
                            aria-label="Disminuir cantidad"
                            onClick={() => this.handleDecrement(item)}
                            disabled={this.state.isExecuting}
                          >
                            {item.productQty === 1 ? <MDBIcon icon="trash-alt" /> : <MDBIcon icon="minus" />}
                          </button>
                          <span className="xext-qty-value">{item.productQty}</span>
                          <button
                            type="button"
                            className="xext-qty-btn xext-qty-plus"
                            aria-label="Aumentar cantidad"
                            onClick={() => this.handleIncrement(item)}
                            disabled={this.state.isExecuting}
                          >
                            <MDBIcon icon="plus" />
                          </button>
                        </div>
                        <XBtn size="sm" color="danger" onClick={() => this.handleDeleteClick(item)}>
                          <MDBIcon icon="trash-alt" /> Eliminar
                        </XBtn>
                      </MDBCol>
                      <MDBCol md="5">
                        <b>{item.productName}</b>
                        <br />
                        SKU: {item.productSKU}
                        {this.state.preventaMap[item.productSKU] === false && (
                          <span className="xext-preventa-pill xext-preventa-pill--pendiente">
                            Preventa: aun no llega
                          </span>
                        )}
                        {this.state.preventaMap[item.productSKU] === true && (
                          <span className="xext-preventa-pill xext-preventa-pill--confirmada">
                            Preventa: lista
                          </span>
                        )}
                      </MDBCol>
                      <MDBCol md="4" className="xext-item-pick">
                        <MDBBadge
                          color={
                            this.state.preventaMap[item.productSKU] !== true
                              ? "danger"
                              : item.isPicked === -1
                              ? "grey"
                              : "success"
                          }
                          style={{
                            cursor: this.state.preventaMap[item.productSKU] !== true ? "not-allowed" : "pointer",
                            opacity: this.state.preventaMap[item.productSKU] !== true ? 0.6 : 1,
                          }}
                          onClick={() => this.handlePick(item.id)}
                        >
                          <MDBIcon icon="check-square" /> Pick ({item.qtyPicked}/{item.productQty})
                        </MDBBadge>
                      </MDBCol>
                    </MDBRow>
                  </MDBCardBody>
                </MDBCard>
              ))}

              {this.state.requiereNotaSapPreventa && (
                <MDBCard className="mt-3 mb-3">
                  <MDBCardHeader>Traspaso de preventa a la tienda de pickup</MDBCardHeader>
                  <MDBCardBody>
                    <MDBRow>
                      <MDBCol md="6">
                        <XInput
                          id="nota_sap_preventa"
                          name="nota_sap_preventa"
                          label="Nota SAP (preventa)"
                          value={this.state.nota_sap_preventa}
                          onChange={this.changeHandler}
                          size="sm"
                        />
                      </MDBCol>
                    </MDBRow>
                  </MDBCardBody>
                </MDBCard>
              )}

              {this.state.tipo_envio !== "weight" && (
                <MDBCard className="mt-3 mb-3">
                  <MDBCardHeader>Retiro en tienda</MDBCardHeader>
                  <MDBCardBody>
                    <MDBRow>
                      <MDBCol md="6">
                        <XInput
                          id="posicion_rack"
                          name="posicion_rack"
                          label="Posición Rack"
                          value={this.state.posicion_rack}
                          onChange={this.changeHandler}
                          size="sm"
                        />
                      </MDBCol>
                    </MDBRow>
                  </MDBCardBody>
                </MDBCard>
              )}

              {this.state.tipo_envio === "weight" && (
                <MDBAlert color="info" className="mt-3 mb-3">
                  La factura de este pedido se emite en Picking Individual, con todos los productos.
                </MDBAlert>
              )}

              <MDBRow className="mt-3">
                <MDBCol className="text-right">
                  <XBtn color="success" onClick={this.executeTask} disabled={this.state.isExecuting}>
                    Pedido listo para entrega
                  </XBtn>
                </MDBCol>
              </MDBRow>
            </>
          )}
        </MDBContainer>

        <MDBModal isOpen={this.state.modalDelete} toggle={() => this.setState({ modalDelete: false })}>
          <MDBModalHeader>Confirmar</MDBModalHeader>
          <MDBModalBody>¿Eliminar este producto de preventa del pedido?</MDBModalBody>
          <MDBModalFooter>
            <XBtn outline color="warning" onClick={() => this.setState({ modalDelete: false })}>
              Cancelar
            </XBtn>
            <XBtn color="danger" onClick={this.confirmDelete}>
              Eliminar
            </XBtn>
          </MDBModalFooter>
        </MDBModal>

        <MDBModal isOpen={this.state.modalAdd} toggle={() => this.setState({ modalAdd: false })}>
          <MDBModalHeader>Agregar producto de preventa</MDBModalHeader>
          <MDBModalBody>
            <MDBRow>
              <MDBCol md="8">
                <XInput id="SKUcode" name="SKUcode" label="SKU" value={this.state.SKUcode} onChange={this.changeHandler} size="sm" />
              </MDBCol>
              <MDBCol md="4">
                <XBtn size="sm" onClick={this.searchProduct}>
                  Buscar
                </XBtn>
              </MDBCol>
            </MDBRow>
            {this.state.searchResults.map((r) => (
              <MDBRow key={r.sku} className="mt-2">
                <MDBCol md="8">
                  {r.name} ({r.sku})
                </MDBCol>
                <MDBCol md="4">
                  <XBtn size="sm" color="success" onClick={() => this.seleccionarProductoAAgregar(r)}>
                    Elegir
                  </XBtn>
                </MDBCol>
              </MDBRow>
            ))}
            {this.state.productoAAgregar && this.state.checkandoSku && (
              <MDBAlert color="info" className="mt-3">
                Validando si <b>{this.state.productoAAgregar.sku}</b> es de preventa…
              </MDBAlert>
            )}
            {this.state.productoAAgregar && !this.state.checkandoSku && this.state.skuEsPreventa === true && (
              <MDBAlert color="success" className="mt-3">
                <MDBIcon icon="check-circle" /> {this.state.skuCheckMessage || "SKU confirmado como preventa"}
              </MDBAlert>
            )}
            {this.state.productoAAgregar && !this.state.checkandoSku && this.state.skuEsPreventa === false && (
              <MDBAlert color="danger" className="mt-3">
                <MDBIcon icon="times-circle" /> {this.state.skuCheckMessage || "Este SKU no es de preventa"}
              </MDBAlert>
            )}
          </MDBModalBody>
          <MDBModalFooter>
            <XBtn outline color="warning" onClick={() => this.setState({ modalAdd: false, productoAAgregar: null })}>
              Cancelar
            </XBtn>
            <XBtn
              color="success"
              onClick={this.addProduct}
              disabled={!this.state.productoAAgregar || this.state.checkandoSku || !this.state.skuEsPreventa}
            >
              Agregar
            </XBtn>
          </MDBModalFooter>
        </MDBModal>

        <ToastContainer hideprogress_Bar={true} newestOnTop={false} />
      </>
    );
  }
}

export default externalForm11;
